import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { orpc } from '@/lib/api/orpc';

/**
 * Login email policy のミューテーション／クエリ。
 *
 * **エラー表示**: 取得失敗は画面内に出すため query はグローバルエラーを抑止。
 * ミューテーション失敗はダイアログ内の `ResponseMessage` にも出す。
 */

const loginEmailPolicy = orpc.loginEmailPolicy;
const LOCAL_ERROR_META = {
  disableGlobalErrorHandling: true
} as const;
export const loginEmailPoliciesQueryOptions = () => ({
  ...loginEmailPolicy.getOrgPolicies.queryOptions({
    input: {}
  }),
  meta: LOCAL_ERROR_META
});
export const useLoginEmailPolicies = () => {
  return useQuery(loginEmailPoliciesQueryOptions());
};
export const useUpsertLoginEmailPolicy = () => {
  const queryClient = useQueryClient();
  return useMutation({
    ...loginEmailPolicy.upsertOrgPolicy.mutationOptions(),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: loginEmailPolicy.getOrgPolicies.key()
      });
    }
  });
};